import { Style } from "./Style";

let defaultStyle;

export class ImageStyle extends Style {
    static get DEFAULT() {
        return defaultStyle || (defaultStyle = new ImageStyle);
    }
    constructor(style = {}, bodyStyle = {}) {
        super(style, bodyStyle);
    }
    clone() {
        return new ImageStyle(this, null);
    }
}
//# sourceMappingURL=ImageStyle.js.map
